import React from "react";

export function CheckboxCard({ label, checked, onChange, className }) {
  const classes = [
    "rma-nc-checkbox-card",
    checked ? "rma-nc-checkbox-card--checked" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <label className={classes}>
      <input
        type="checkbox"
        checked={checked}
        onChange={function (event) {
          onChange(event.target.checked);
        }}
      />
      <span>{label}</span>
    </label>
  );
}

// A grid of CheckboxCards over a fixed option list.
export function CheckboxCardGrid({ options, value, onChange, className }) {
  function toggle(option, checked) {
    onChange(
      checked
        ? [...value, option]
        : value.filter(function (item) {
            return item !== option;
          }),
    );
  }

  const classes = ["rma-nc-checkbox-grid", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      {options.map(function (option) {
        return (
          <CheckboxCard
            key={option}
            label={option}
            checked={value.includes(option)}
            onChange={function (checked) {
              toggle(option, checked);
            }}
          />
        );
      })}
    </div>
  );
}
